import React, { useContext, useEffect } from "react";
import { useIntl } from "react-intl";
import { NotificationsContext } from "@ui-components/Notifications";
import UserNotificationsContext from "../../UserNotificationsContext";

import useWorksiteTask from "@components/WorksiteTask/hooks/useWorksiteTask";
import MainTaskForm from "@components/WorksiteTask/MainTaskForm";

export const TaskDetail = ({
  worksite,
  task_id = undefined,
  activity_id = undefined,
  survey_id = undefined,
  note_id = undefined,
  template_id = undefined,
  onSubmit = undefined,
  onClose = undefined,
}) => {
  const { push } = useContext(NotificationsContext);
  const intl = useIntl();
  const changingExisting = task_id !== undefined;

  const { worksiteTask, fetchTask } = useWorksiteTask(task_id);
  const { userNotifications, setUserNotifications } = useContext(
    UserNotificationsContext
  );

  useEffect(() => {
    if (!userNotifications || !worksite?.id) {
      return;
    }
    // Delete notifications for the given task
    // We delete notifications of types
    // worksite_tasks
    const notificationsToRemove = userNotifications
      ?.filter(
        (n) =>
          n.val_type === "worksites_tasks" &&
          parseInt(n.cod_worksite_task) === parseInt(task_id)
      )
      ?.map((n) => n.id);
    if (notificationsToRemove.length) {
      setUserNotifications((prev) =>
        prev.filter((n) => !notificationsToRemove.includes(n.id))
      );
    }
  }, [worksite, task_id, setUserNotifications, userNotifications]);

  if (changingExisting && !worksiteTask) {
    return <></>;
  }

  return (
    <>
      <MainTaskForm
        changingExisting={changingExisting}
        worksite={worksite}
        template_id={template_id}
        worksite_task={worksiteTask}
        survey_id={survey_id}
        activity_id={activity_id}
        note_id={note_id}
        onClose={() => {
          if (onClose) {
            onClose();
          }
        }}
        onSubmit={(close, notify = true) => {
          if (notify) {
            if (close) {
              push({
                type: "success",
                title: intl.formatMessage({ id: "task_saved" }),
              });
            } else {
              push({
                type: "success",
                title: intl.formatMessage({ id: "task_updated" }),
                timeout: 2000,
              });
            }
          }
          if (!close) {
            // refetch to show updated task on form
            // only if not closing the form
            fetchTask();
          }
          if (onSubmit) {
            onSubmit(close);
          }
        }}
      />
    </>
  );
};

export default TaskDetail;
